import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

declare var CSL: any; // citeproc.js, CSL citation formatting language library

@Injectable({
	providedIn: 'root'
})
export class CitationService {

	supportedLanguages: string[] = ["en"];
	supportedFormats: string[] = [
		"american-medical-association",
		"apa",
		"chicago-author-date",
		"chicago-fullnote-bibliography",
		"chicago-note-bibliography",
		"modern-language-association",
		"turabian-author-date"
	];
	mapping: any = {};

	constructor(private http: HttpClient) {
		this.loadCitationAssets();
		this.buildMapping();
	}
	
	private loadCitationAssets(): void {
		const jsSrc = '/app/aw-ui-angular/assets/vendor/citations/citeproc.js';

		if (!document.querySelector(`script[src="${jsSrc}"]`)) {
			const script = document.createElement('script');
			script.src = jsSrc;
			script.defer = true;
			document.body.appendChild(script);
		}
	}


	private buildMapping(): void {
		let url = '~/../app/load/citation/citation-mapping.json';

		this.http.get(url).subscribe({
			next: (response: any) => {
				this.mapping = response;
			},
			error: () => {
				this.mapping = {};
				console.error('Failed to retrieve citation mappings.');
			}
		});
	}

	// Returns a promise to preserve original client caller syntax
	async createBibliography(citationData: any = {}, language: string = 'en', style: string = 'apa', ids: string[]): Promise<any> {
		try {
			// Create the citeproc system object
			const citeprocSys = {
				// Handle this synchronously
				retrieveLocale: (lang: string): string => {
				  const url = `~/../app/load/citation/locales-${lang}.xml`;

				  const response = firstValueFrom(this.http.get(url, { responseType: 'text' }));
				  
				  const xhr = new XMLHttpRequest();
				  xhr.open('GET', url, false);  // Force the synchronous behavior
				  xhr.send();

				  if (xhr.status === 200) {
				    return xhr.responseText;
				  } else {
				    throw new Error('Failed to load locale file');
				  }
				},
				retrieveItem: (id: string): any => citationData[id]
			};

			// Fetch the style file (.csl)
			const styleAsText = await firstValueFrom(this.http.get(`~/../app/load/citation/${style}.csl`, { responseType: 'text' }));

			const citeproc = new CSL.Engine(citeprocSys, styleAsText);
			citeproc.updateItems(ids);
			const bibResult = citeproc.makeBibliography();
			return bibResult;
		} catch (err) {
			console.error('Error in createBibliography:', err);
			throw new Error('Failed to create bibliography');
		}
	}
}
